import React, { useRef } from "react";
import {
	createUserWithEmailAndPassword,
	signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../../firebase";
import "./Login.css";
import { useNavigate } from "react-router-dom";

function Login() {
	const emailRef = useRef(null);
	const passwordRef = useRef(null);
	const history = useNavigate();

	const register = (e) => {
		e.preventDefault();
		createUserWithEmailAndPassword(
			auth,
			emailRef.current.value,
			passwordRef.current.value
		)
			.then((authUser) => {
				console.log(authUser);
			})
			.catch((error) => {
				alert(error.message);
			});
	};

	const signin = (e) => {
		e.preventDefault();
		signInWithEmailAndPassword(
			auth,
			emailRef.current.value,
			passwordRef.current.value
		)
			.then((authUser) => {
				history("/");
			})
			.catch((error) => {
				alert(error.message);
			});
	};

	return (
		<div className="signin">
			<form>
				<h1>Sign In</h1>
				<input
					ref={emailRef}
					type="email"
					placeholder="Email address"
					className="signin__input"
				/>
				<input
					ref={passwordRef}
					type="password"
					placeholder="Password"
					className="signin__input"
				/>
				<button type="submit" onClick={signin} className="signin__submit">
					Sign In
				</button>
				<p className="signin__footer">
					New to Rokflix?{" "}
					<span className="signin__link" onClick={register}>
						Sign up now
					</span>
				</p>
			</form>
		</div>
	);
}

export default Login;
